











import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    title: { type: String, default: '', required: false },
    diameter: { type: [Number, String], default: 14, required: false }
  },
  setup() {
    return {}
  }
})
